import React, { useCallback, useState } from 'react';
import classnames from 'classnames';
import range from 'lodash/range';

import Icon from '../../../../common/components/icon/Icon';
import Button, {
  appearances,
} from '../../../../common/components/controls/button/Button';
import Field, {
  FIELD_TYPES,
} from '../../../../common/components/forms/field/Field';

import './UserSatisfactionFeedbackForm.scss';

const starIndexMessages = [
  'Terrible, please improve!',
  'Bad, please improve!',
  'Could be better!',
  'Works Well!',
  'Perfect!',
];

const RATING_STARS_COUNT = 5;

export interface UserSatisfactionFeedbackFormProps {
  className?: string;
  onSubmit;
}

const UserSatisfactionFeedbackForm = ({
  className,
  onSubmit,
}: UserSatisfactionFeedbackFormProps) => {
  const [rating, setRating] = useState<number | null>(null);
  const [comment, setComment] = useState('');

  const handleFeedbackSubmissionClick = useCallback(() => {
    if (onSubmit) {
      onSubmit({ rating, comment });
    }
  }, [rating, comment, onSubmit]);

  return (
    <div className={classnames('user-satisfaction-feedback-form', className)}>
      <h2 className="user-satisfaction-feedback-form__title">
        Please rate your feedback experience
      </h2>
      <div className="user-satisfaction-feedback-form__rating">
        {range(RATING_STARS_COUNT).map((i) => (
          <button
            key={i}
            // the order is reversed to have highlighting done with plain CSS
            onClick={() =>
              setRating((prevRating) =>
                prevRating === RATING_STARS_COUNT - i
                  ? null
                  : RATING_STARS_COUNT - i,
              )
            }
            className={classnames(
              'user-satisfaction-feedback-form__rating-star-button',
              {
                'user-satisfaction-feedback-form__rating-star-button--selected':
                  rating === RATING_STARS_COUNT - i,
              },
            )}
          >
            <Icon name="score-star" />
          </button>
        ))}
      </div>
      <span className="user-satisfaction-feedback-form__rating-message">
        {rating ? starIndexMessages[rating - 1] : ''}
      </span>
      <Field
        className="user-satisfaction-feedback-form__comments-field"
        type={FIELD_TYPES.textArea}
        label="Comments"
        value={comment}
        controlProps={{
          placeholder: 'Add here some additional information',
        }}
        onChange={(_, value) => setComment(value)}
      />
      {!!rating && (
        <Button
          className="user-satisfaction-feedback-form__send-button"
          appearance={appearances.PRIMARY}
          onClick={handleFeedbackSubmissionClick}
        >
          Submit Feedback
        </Button>
      )}
    </div>
  );
};

export default UserSatisfactionFeedbackForm;
